import { useEffect } from 'react';
import { view, bowser, hdrm } from '@yola/ws-sdk';
import customUI from 'src/js/modules/custom-ui';

const useControlShowingOnScroll = (config = {}, componentsProps = {}) => {
  const { controlShowingOnScroll } = config;
  const { elementId } = componentsProps;
  const liveDocument = view.accessors.getLiveDocument();
  const windowHeight = liveDocument?.defaultView?.innerHeight || 0;
  const isAppleWithTouch = bowser.ios || bowser.iPadOS;

  useEffect(() => {
    const handleScroll = hdrm.helpers.WSInternalEvent.bind(null, () => {
      const scrollPosition = view.accessors.getScrollPosition();
      const element = view.accessors.getLiveElement(elementId);
      const elementOffset = view.accessors.getElementOffset(element);
      const elementBounds = element.getBoundingClientRect();
      const { height } = elementBounds;

      if (
        scrollPosition > elementOffset + height ||
        elementOffset > scrollPosition + windowHeight
      ) {
        customUI.operations.hide();
      }
    });

    if (controlShowingOnScroll && elementId) {
      if (isAppleWithTouch) {
        liveDocument?.addEventListener('touchmove', handleScroll, true);
      } else {
        liveDocument?.addEventListener('scroll', handleScroll);
      }
    }

    return () => {
      if (controlShowingOnScroll && elementId) {
        if (isAppleWithTouch) {
          liveDocument?.removeEventListener('touchmove', handleScroll, true);
        } else {
          liveDocument?.removeEventListener('scroll', handleScroll);
        }
      }
    };
  }, [controlShowingOnScroll, elementId, liveDocument, windowHeight, isAppleWithTouch]);
};

export default useControlShowingOnScroll;
